export default {
  loadingText: 'กำลังโหลดข้อมูล...',
  noDataText: 'ไม่พบข้อมูล',
  itemPerPage: 'รายการต่อหน้า',
  title: {
    create: 'สร้างส่วนผสมใหม่',
    edit: 'แก้ไขข้อมูลส่วนผสม',
    detail: 'รายละเอียดส่วนผสม'
  },
  label: {
    no: 'รหัสส่วนผสม',
    category: 'หมวดหมู่',
    nameCategory: 'หมวดหมู่ส่วนผสม',
    editNameCategory: 'แก้ไขหมวดหมู่ส่วนผสม',
    status: 'สถานะ',
    name: 'ชื่อส่วนผสม',
    nameTh: 'ชื่อส่วนผสม',
    nameEn: 'ชื่อส่วนผสม (EN)',
    nameCn: 'ชื่อส่วนผสม (CN)',
    brand: 'ยี่ห้อ',
    unitName: 'ชื่อหน่วยส่วนผสม',
    unitIngredient: 'หน่วยส่วนผสม',
    importUnit: 'หน่วยนำเข้า',
    subUnit: 'หน่วยย่อย',
    pricePerUnit: 'ราคาขาย (หน่วยย่อย)',
    minQuantity: 'ปริมาณต่ำสุด (หน่วยย่อย)',
    maxQuantity: 'ปริมาณสูงสุด (หน่วยย่อย)',
    note: 'หมายเหตุ',
    remaining: 'ปริมาณคงเหลือ (หน่วยย่อย)'
  },
  placeholder: {
    search: 'ค้นหารหัสส่วนผสม ชื่อส่วนผสม',
    category: 'เลือกหมวดหมู่',
    status: 'เลือกสถานะ',
    name: 'กรอกชื่อส่วนผสม',
    no: 'กรอกรหัสส่วนผสม',
    nameEn: 'กรอกชื่อส่วนผสม (EN)',
    nameCn: 'กรอกชื่อส่วนผสม (CN)',
    brand: 'กรอกชื่อยี่ห้อ',
    unitIngredient: 'กรอกหน่วยส่วนผสม',
    searchUnitIngredient: 'ค้นหาชื่อหน่วยส่วนผสม',
    unitIngredientInfo: 'กรอกข้อมูลหน่วยส่วนผสม',
    importUnit: 'เลือกหน่วยนำเข้า',
    subUnit: 'เลือกหน่วยย่อย',
    pricePerUnit: 'กรอกราคาขายต่อหน่วยย่อย',
    minQuantity: 'กรอกปริมาณต่ำสุด',
    maxQuantity: 'กรอกปริมาณสูงสุด',
    note: 'กรอกหมายเหตุ',
    nameCategory: 'กรอกข้อมูลหมวดหมู่ส่วนผสม'
  },
  header: {
    no: 'รหัสส่วนผสม',
    name: 'ชื่อส่วนผสม',
    category: 'หมวดหมู่',
    remaining: 'ปริมาณคงเหลือ',
    status: 'สถานะ'
  },
  tooltip: {
    create: 'สร้างส่วยผสมใหม่',
    print: 'พิมพ์',
    detail: 'ดูข้อมูลส่วนผสม',
    edit: 'แก้ไขข้อมูล',
    delete: 'ลบข้อมูล',
    importUnit: 'หน่วยที่บันทึกเมื่อนำส่วนผสมเข้าระบบ',
    subUnit: 'หน่วยที่ใช้ตัดสต็อกเมื่อมีการขายหรือใช้ส่วนผสม',
    pricePerUnit: 'ราคาขายต่อ 1 หน่วยย่อย',
    minQuantity: 'ปริมาณคงเหลือต่ำสุดของส่วนผสมในระบบ',
    maxQuantity: 'ปริมาณคงเหลือสูงสุดของส่วนผสมในระบบ',
    remaining: 'ปริมาณคงเหลือของส่วนผสมในระบบ'
  },
  button: {
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    back: 'ย้อนกลับ',
    confirm: 'ยืนยัน'
  },
  alert: {
    create: 'สร้างส่วนผสมสำเร็จ !',
    edit: 'แก้ไขส่วนผสมสำเร็จ !',
    delete: 'ลบส่วนผสมสำเร็จ !'
  },
  status: {
    all: 'ทั้งหมด',
    controlled: 'อยู่ในปริมาณควบคุม',
    exceed: 'เกินปริมาณควบคุม',
    lower: 'ต่ำกว่าปริมาณควบคุม'
  },
  modal: {
    create: {
      title: 'ยืนยันการแก้ไขส่วนผสม',
      subtitle: 'คุณกำลังแก้ไขส่วนผสม ต้องการดำเนินการต่อหรือไม่ ?',
      success: 'เพิ่มหมวดหมู่ส่วนผสมสำเร็จ !',
      successUnit: 'เพิ่มหน่วยส่วนผสมสำเร็จ !'
    },
    edit: {
      title: 'ยืนยันการแก้ไขส่วนผสม',
      subtitle: 'คุณกำลังแก้ไขส่วนผสม ต้องการดำเนินการต่อหรือไม่ ?',
      success: 'แก้ไขหมวดหมู่ส่วนผสมสำเร็จ !',
      unitSuccess: 'แก้ไขหน่วยส่วนผสมสำเร็จ'
    },
    delete: {
      title: 'ยืนยันการลบส่วนผสม',
      subtitle: 'คุณกำลังลบส่วนผสม ต้องการดำเนินการต่อหรือไม่ ?',
      categoryTitle: 'ยืนยันการหมวดหมู่ส่วนผสม !',
      categorySubtitle: 'คุณกำลังลบหมวดหมู่ส่วนผสม ต้องการดำเนินการต่อหรือไม่ ?',
      categorySuccess: 'ลบหมวดหมู่ส่วนผสมสำเร็จ !',
      unitTitle: 'ยืนยันการลบหมวดหมู่ส่วนผสม !',
      unitSubtitle: 'คุณกำลังลบหน่วยส่วนผสม ต้องการดำเนินการต่อหรือไม่ ?',
      unitSuccess: 'ลบหมวดหมู่ส่วนผสมสำเร็จ !'
    }
  }
}
